import { defineStore } from 'pinia';
import { Ref, ref } from 'vue';

export const useUserActivityStore = defineStore('user-activity', () => {
  const lastInteraction: Ref<number | undefined> = ref(undefined);

  const addOrUpdateNumber = (now: number) => {
    lastInteraction.value = now;
  };

  const getNumber = () => {
    return lastInteraction.value;
  };

  return {
    addOrUpdateNumber,
    getNumber,
  };
});
